import * as actionTypes from './actionTypes';


// reducers
export const changeAutValue = (key, value) => ({ type: actionTypes.AUT_CHANGE_SYSTEM, key: key, value: value })
export const setAutTransformationMethod = (tm) => ({ type: actionTypes.AUT_SET_TM, transformationMethod: tm })